import * as React from 'react';
import { plural } from '@cian/utils';
import { clsx } from 'clsx';
import { Fact } from '../../components/Fact';
import { TFactDirection } from '../../components/Fact/types';
import * as styles from './NewBuildingFacts.css';

interface INewBuildingFactsProps {
  newBuildingsInProcess?: number | null;
  housesInProcess?: number | null;
  readyNewBuildings?: number | null;
  readyHouses?: number | null;
  foundationYear?: number | null;
  direction?: TFactDirection;
  hasPoster: boolean;
  variant?: 'default' | 'fsk';
}

export function NewBuildingFacts({
  newBuildingsInProcess,
  housesInProcess,
  readyNewBuildings,
  foundationYear,
  readyHouses,
  direction,
  hasPoster,
  variant = 'default',
}: INewBuildingFactsProps) {
  const facts = React.useMemo(
    () =>
      getFacts({
        newBuildingsInProcess,
        housesInProcess,
        readyNewBuildings,
        foundationYear,
        readyHouses,
      }),
    [newBuildingsInProcess, housesInProcess, readyNewBuildings, foundationYear, readyHouses],
  );

  return (
    <ul className={clsx({ [styles['standard']]: variant === 'default' }, { [styles['fsk']]: variant === 'fsk' })}>
      {facts.map((fact, index) => {
        if (!fact || !fact.mainText || !fact.additionalText) {
          return null;
        }

        return (
          <li key={index} className={styles['item']}>
            <Fact
              mainText={fact.mainText}
              additionalText={fact.additionalText}
              additionalMaxWidth={fact.additionalMaxWidth}
              direction={direction}
              textColor={hasPoster ? 'white_100' : 'black_100'}
            />
          </li>
        );
      })}
    </ul>
  );
}

function getFacts({
  foundationYear,
  newBuildingsInProcess,
  housesInProcess,
  readyNewBuildings,
  readyHouses,
}: Partial<INewBuildingFactsProps>) {
  return [
    { mainText: foundationYear, additionalText: 'год основания компании' },
    housesInProcess &&
      newBuildingsInProcess && {
        mainText: housesInProcess,
        additionalText: `${plural(housesInProcess, ['дом', 'дома', 'домов'])} строится в ${newBuildingsInProcess} ЖК`,
      },
    readyHouses &&
      readyNewBuildings && {
        mainText: readyHouses,
        additionalText: `${plural(readyHouses, ['дом сдан', 'дома сдано', 'домов сдано'])} в ${readyNewBuildings} ЖК`,
        additionalMaxWidth: '85px',
      },
  ];
}
